module.exports = __webpack_public_path__ + "img/4.16713a53.jpg";